import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import VideoEmbed from 'components/shared/video-embed';

const VideoGuide = ({
  theme,
  direction,
  labelTheme,
  label,
  title,
  description,
  videoid,
  sectionId,
}) => (
  <section
    id={sectionId}
    className={clsx(
      'video-guide safe-paddings relative pt-40 xl:pt-30 lg:pt-28 md:pt-20',
      theme === 'dark' && 'bg-new-gray-2'
    )}
  >
    <div className="container grid-gap grid grid-cols-12 justify-between gap-y-7 md:max-w-none sm:gap-y-3.5">
      <div
        className={clsx(
          'col-span-6 lg:order-1 lg:col-start-2 lg:col-span-10 sm:col-span-full',
          direction === 'left' && 'col-start-7'
        )}
      >
        <VideoEmbed
          className={clsx(
            'relative overflow-hidden rounded-[14px] shadow-[0px_5px_15px_rgba(23,26,28,0.15),0px_2px_5px_rgba(23,26,28,0.10)] lg:w-full',
            direction === 'right' && 'max-w-[555px] lg:max-w-none'
          )}
          embedId={videoid}
          embedType="youtube"
          videoWidth={560}
          videoHeight={315}
        />
      </div>
      <div
        className={clsx(
          'self-center lg:col-span-10 lg:col-start-2 lg:flex lg:flex-col lg:items-center md:w-full sm:col-span-full',
          labelTheme === 'transparent' && 'col-span-4 xl:col-span-5 ',
          labelTheme === 'yellow' && 'col-span-5',
          direction === 'left' && labelTheme === 'transparent' && 'col-start-2 row-start-1',
          direction === 'left' && labelTheme === 'yellow' && 'col-start-1 row-start-1',
          direction === 'right' && 'col-start-8 xl:col-start-8'
        )}
      >
        <span
          className={clsx(
            'inline-flex items-center',
            labelTheme === 'transparent' &&
              'px-3.5 pt-3 pb-2 rounded-full text-new-black text-sm leading-none shadow-[0px_2px_4px_rgba(92,112,214,0.2),0px_3px_10px_rgba(230,233,248,0.7)]',
            labelTheme === 'yellow' &&
              'rounded bg-primary-1 py-1 px-3.5 text-base font-bold tracking-wide'
          )}
        >
          {label}
        </span>
        <h2
          className={clsx(
            'text-balance text-4xl xl:mt-4 lg:mt-3.5 lg:text-center lg:text-[28px] lg:max-w-lg md:text-[24px]',
            labelTheme === 'transparent' &&
              'mt-5 leading-denser font-medium tracking-tight-4 text-new-black',
            labelTheme === 'yellow' && 'mt-3.5 font-bold leading-tight'
          )}
        >
          {title}
        </h2>
        <p
          className={clsx(
            'text-balance xl:mt-4 lg:mt-3.5 lg:text-center lg:text-[18px] md:text-[16px]',
            labelTheme === 'transparent' &&
              'mt-3.5 max-w-[360px] text-new-gray-1 font-light text-xl leading-snug lg:max-w-none',
            labelTheme === 'yellow' && 'mt-4 max-w-[490px] text-lg lg:max-w-none'
          )}
        >
          {description}
        </p>
      </div>
    </div>
  </section>
);

VideoGuide.propTypes = {
  theme: PropTypes.string,
  direction: PropTypes.string,
  labelTheme: PropTypes.string,
  label: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  videoid: PropTypes.string.isRequired,
  sectionId: PropTypes.string,
};

VideoGuide.defaultProps = {
  theme: 'light',
  direction: 'right',
  labelTheme: 'transparent',
  sectionId: null,
};

export default VideoGuide;
